export const getSensordataByDeviceID = 'monitoring/getSensordataByDeviceID';
export const getEventsByID = 'monitoring/getEventsByID';
